import { authApi, configureApiClient } from '@shared/api-client';

/**
 * `import.meta.env` is populated by Vite from `config/.env.*` through dotenvx.
 * Failing loudly here beats every request 404ing against a relative path.
 */
const baseUrl = import.meta.env.VITE_API_BASE_URL;

if (!baseUrl) {
  throw new Error(
    'VITE_API_BASE_URL is not set. Run through the dev or build script so dotenvx loads config/.env.*',
  );
}

let onUnauthorized: (() => void) | null = null;

/**
 * The session hook registers here rather than the client importing React state,
 * which would make @shared/api-client depend on the web app.
 */
export const setUnauthorizedHandler = (handler: () => void): void => {
  onUnauthorized = handler;
};

configureApiClient({
  baseUrl,
  // Sends the HttpOnly session cookies. The API allowlists this origin.
  credentials: 'include',
  // Access tokens last one hour; the HttpOnly refresh cookie keeps the browser
  // signed in for up to 30 days. The client retries the request after renewal.
  renewSession: async () => {
    await authApi.refreshSession();
  },
  onUnauthorized: () => onUnauthorized?.(),
});
